import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useEffect, useState } from "react";
import { BarChart, Bar, Brush, XAxis, Legend, ResponsiveContainer, Tooltip, LabelList, Label } from "recharts";
import { CustomizedMonthTick, CustomizedTooltip, CustomizedYearLegend, COLORS, CustomizedLabel, CustomizedKLabel } from "../shared";
import { generateStackedGroupDataBy } from "../../../core/auxFunctions";
import moment from "moment";
import _ from "lodash"; // const COLORS = ["#33ff99", "#00cdd6", "#0093ff", "#0400b5"];

var StackedGroupBarChart = function StackedGroupBarChart(_ref) {
  var dataRaw = _ref.dataRaw,
      field = _ref.field,
      acc = _ref.acc,
      groupedBy = _ref.groupedBy,
      brush = _ref.brush,
      legend = _ref.legend,
      stackedBy = _ref.stackedBy,
      translation = _ref.translation,
      locale = _ref.locale,
      groups = _ref.groups,
      props = _objectWithoutProperties(_ref, ["dataRaw", "field", "acc", "groupedBy", "brush", "legend", "stackedBy", "translation", "locale", "groups"]);

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      formatedData = _useState4[0],
      setFormatedData = _useState4[1];

  useEffect(function () {
    if (dataRaw) {
      var dataRawFormated = generateStackedGroupDataBy(dataRaw, field, stackedBy, acc);
      var newDataRawFormated = dataRawFormated.reduce(function (acc, val) {
        var findItem = acc.find(function (item) {
          return item.key === val.key;
        });

        if (findItem) {
          acc.forEach(function (dataItem, index) {
            if (dataItem.key === val.key) {
              acc[index] = _objectSpread(_objectSpread({}, acc[index]), val);
            }
          });
        } else {
          acc.push(_objectSpread({}, val));
        }

        return acc;
      }, []); // console.log("data to format", newDataRawFormated, dataRawFormated);

      dataRaw && setData(newDataRawFormated);
    }
  }, [dataRaw]);
  useEffect(function () {
    if (data) {
      var dataFormated = data.reduce(function (acc, val) {
        var _loop = function _loop(key) {
          if (key === "key" || key === "") return "continue";
          var id = key.split("_")[0];
          acc.forEach(function (group, position) {
            if (group.id === id) {
              if (!group.keys.includes(key)) {
                acc[position].keys.push(key);
              }
            }
          });
        };

        for (var key in val) {
          var _ret = _loop(key);

          if (_ret === "continue") continue;
        }

        return acc;
      }, _toConsumableArray(groups.map(function (group) {
        return {
          id: group,
          keys: []
        };
      }))).sort(); // console.log("formated data in stacked bar", dataFormated);

      setFormatedData(dataFormated);
    }
  }, [data]);
  return /*#__PURE__*/React.createElement(ResponsiveContainer, {
    height: props.height || 200
  }, /*#__PURE__*/React.createElement(BarChart, {
    width: 600,
    height: props.height || 200,
    data: data,
    margin: {
      top: 20,
      right: 30,
      left: 20,
      bottom: 5
    }
  }, /*#__PURE__*/React.createElement(XAxis, {
    interval: "preserveStart",
    angle: 30,
    dataKey: "key",
    tickMargin: "15",
    tick: /*#__PURE__*/React.createElement(CustomizedMonthTick, null)
  }), /*#__PURE__*/React.createElement(Tooltip, {
    translation: translation ? translation : null,
    content: CustomizedTooltip,
    locale: locale
  }), legend && /*#__PURE__*/React.createElement(Legend, {
    translation: translation,
    verticalAlign: "top",
    offset: true,
    content: CustomizedYearLegend,
    locale: locale
  }), formatedData && formatedData.map(function (group) {
    return group.keys.map(function (element, idx) {
      return /*#__PURE__*/React.createElement(Bar, {
        key: element,
        fill: COLORS[element.split("_")[1]],
        dataKey: element,
        stackId: group.id,
        isAnimationActive: false
      }, props.label && idx === group.keys.length - 1 ? /*#__PURE__*/React.createElement(LabelList // offset={20}
      // position="top"
      , {
        content: function content(props) {
          return /*#__PURE__*/React.createElement(CustomizedKLabel, Object.assign({}, props, {
            year: group.id
          }));
        }
      }) : null);
    });
  }), brush && /*#__PURE__*/React.createElement(Brush, {
    dataKey: "key",
    height: 10,
    tickFormatter: function tickFormatter(value) {
      return moment(value, "MM").format("MMMM");
    }
  })));
};

export { StackedGroupBarChart };